import { useRef, useState } from 'react';

export default function useScannerState() {
  const [selectedImage, setSelectedImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [fieldGroups, setFieldGroups] = useState({
    primaryFields: [],
    additionalFields: []
  });
  const [primaryFieldValues, setPrimaryFieldValues] = useState({});
  const [additionalFields, setAdditionalFields] = useState([]);
  const [isScanning, setIsScanning] = useState(false);
  const [scanError, setScanError] = useState('');
  const [showRateLimitModal, setShowRateLimitModal] = useState(false);
  const [rateLimitMessage, setRateLimitMessage] = useState('');
  const [showInsufficientCreditsModal, setShowInsufficientCreditsModal] = useState(false);
  const [creditBalance, setCreditBalance] = useState(0);

  const uploadRef = useRef(null);
  const activeRequestIdRef = useRef(0);

  const resetDetailsState = () => {
    setFieldGroups({ primaryFields: [], additionalFields: [] });
    setPrimaryFieldValues({});
    setAdditionalFields([]);
  };

  const scrollToUpload = () => {
    if (typeof window !== 'undefined' && typeof window.scrollTo === 'function') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    if (uploadRef.current && typeof uploadRef.current.scrollIntoView === 'function') {
      uploadRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const handlePrimaryFieldChange = (fieldKey, value) => {
    setPrimaryFieldValues((current) => ({
      ...current,
      [fieldKey]: value
    }));
  };

  const handleAdditionalFieldLabelChange = (index, label) => {
    setAdditionalFields((items) => {
      const next = [...items];
      next[index] = {
        ...next[index],
        attribute: label
      };
      return next;
    });
  };

  const handleAdditionalFieldValueChange = (index, value) => {
    setAdditionalFields((items) => {
      const next = [...items];
      next[index] = {
        ...next[index],
        value
      };
      return next;
    });
  };

  const handleAddAdditionalField = () => {
    setAdditionalFields((items) => [
      ...items,
      { attribute: '', value: '' }
    ]);
  };

  const handleRemoveAdditionalField = (indexToRemove) => {
    setAdditionalFields((items) =>
      items.filter((_, index) => index !== indexToRemove)
    );
  };

  return {
    selectedImage,
    setSelectedImage,
    imagePreview,
    setImagePreview,
    fieldGroups,
    setFieldGroups,
    primaryFieldValues,
    setPrimaryFieldValues,
    additionalFields,
    setAdditionalFields,
    isScanning,
    setIsScanning,
    scanError,
    setScanError,
    showRateLimitModal,
    setShowRateLimitModal,
    rateLimitMessage,
    setRateLimitMessage,
    showInsufficientCreditsModal,
    setShowInsufficientCreditsModal,
    creditBalance,
    setCreditBalance,
    uploadRef,
    activeRequestIdRef,
    resetDetailsState,
    scrollToUpload,
    handlePrimaryFieldChange,
    handleAdditionalFieldLabelChange,
    handleAdditionalFieldValueChange,
    handleAddAdditionalField,
    handleRemoveAdditionalField
  };
}
